
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opinions/[slug]",
      function () {
        return require("private-next-pages/opinions/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opinions/[slug]"])
      });
    }
  